/*
    converts react-table state to django rest framework compatible
    query strings
*/
export function drfQueryParams(page = 0, pageSize = 20, filters = [], sorted = [], filter_contains = false) {
  const params = {
    limit: pageSize,
    offset: page * pageSize,
    ordering: ''
  };

  const ordering = sorted.map(x => (x.desc ? '-' : '') + x.id);

  params.ordering = ordering.join(',');

  const filtermap = {};
  if (filter_contains) {
    filters.forEach((ele) => {
      filtermap[`${ele.id}__icontains`] = ele.value;
    });
  }
  else {
    filters.forEach((ele) => {
      filtermap[ele.id] = ele.value;
    });
  }

  return Object.assign(params, filtermap);
}

// Return a blank Api parameters object, or create from an existing one.
export function apiParams(params = {
  page: 0,
  pageSize: null,
  filters: [],
  sorted: []
}) {
  return { ...params };
}
